import React, { useEffect } from 'react'
import { useAuthorizedController } from './AuthorizedController';
import { Roles } from '../../../utilities/enums/Roles';
import RulesPage from '../../../pages/public/rules/Rules';

interface IAuthorized {
  children: JSX.Element;
  roles?: Roles[] | null;
  type?: 'page' | 'comp';
}

const Authorized = (props: IAuthorized) => {
  const { children, roles, type } = props;
  const {
    // functions
    validateRoles,
    // clearValidation,
    // state
    isAuthorized,
  } = useAuthorizedController(roles);

  // trigger useEffect on role change
  useEffect(() => {
    const tryValidation = async () => {
      await validateRoles();
    }
    tryValidation().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles, isAuthorized])

  return (
    isAuthorized
      ? (<>{children}</>)
      : (type === 'page')
        ? (<RulesPage />)
        : null
  )
}

export default Authorized